/**
 * Page: Change Password (Refactored)
 *
 * Changement de mot de passe utilisateur.
 * Utilise uniquement authContext.
 */

import { authContext } from '@/scripts/utils/auth-context.js';
import { KratosFlows } from '@/scripts/api/ory-client.js';
import { alert } from '@/scripts/utils/alert-message.js';

document.addEventListener('DOMContentLoaded', async () => {
  // ============================================
  // INITIALIZATION
  // ============================================
  await authContext.init();

  // ✅ Page indépendante : nettoyer tout journey en cours
  if (authContext.getCurrentJourney()) {
    authContext.clearJourney();
  }

  // ✅ Vérification simple : doit être connecté
  if (!authContext.isAuthenticated()) {
    window.location.href = '/login.html';
    return;
  }

  // ✅ authContext.init() a déjà capturé les paramètres URL
  let flowId = authContext.has('flow') ? authContext.get('flow') : null;
  let settingsFlow;

  try {
    if (flowId) {
      settingsFlow = await KratosFlows.getFlow(flowId, 'settings');
    } else {
      settingsFlow = await KratosFlows.initSettingsFlow();
      flowId = settingsFlow.id;
      window.history.replaceState({}, '', `${window.location.pathname}?flow=${flowId}`);
    }
  } catch (error) {
    console.error('[Change Password] Error initializing settings flow:', error);
    alert.error('#alert-container', 'Erreur lors de l\'initialisation. Veuillez actualiser la page.', {
      icon: true,
      closable: true
    });
    return;
  }

  // ============================================
  // FORMULAIRE: Changement de mot de passe
  // ============================================
  const form = document.querySelector('form');
  if (!form) return;

  form.addEventListener('submit', async (e) => {
    e.preventDefault();
    const formData = new FormData(form);
    const submitButton = form.querySelector('button[type="submit"]');

    const password = formData.get('password');
    const passwordConfirm = formData.get('password_confirm');

    // Validation côté client
    if (password !== passwordConfirm) {
      alert.error('#alert-container', 'Les mots de passe ne correspondent pas.', {
        icon: true,
        closable: true
      });
      return;
    }

    if (password.length < 8) {
      alert.error('#alert-container', 'Le mot de passe doit contenir au moins 8 caractères.', {
        icon: true,
        closable: true
      });
      return;
    }

    submitButton.disabled = true;
    submitButton.textContent = 'Mise à jour...';

    try {
      // Récupérer CSRF token
      const currentFlow = await KratosFlows.getFlow(flowId, 'settings');
      const csrfToken = currentFlow.ui.nodes.find(n => n.attributes.name === 'csrf_token')?.attributes.value;

      // Soumettre
      await KratosFlows.submitFlow(flowId, 'settings', {
        method: 'password',
        password: password,
        csrf_token: csrfToken,
      });

      alert.success('#alert-container', 'Mot de passe modifié avec succès !', {
        icon: true,
        closable: true,
        duration: 3000
      });

      // Reset form
      form.reset();
      submitButton.disabled = false;
      submitButton.textContent = 'Mettre à jour le mot de passe';

    } catch (error) {
      console.error('[Change Password] Error changing password:', error);

      submitButton.disabled = false;
      submitButton.textContent = 'Mettre à jour le mot de passe';

      const flowData = error.response?.data;
      const globalErrors = flowData?.ui?.messages?.filter(m => m.type === 'error') || [];
      const nodeErrors = flowData?.ui?.nodes
        ?.flatMap(n => n.messages?.filter(m => m.type === 'error') || []) || [];

      const errorMsg = [...nodeErrors, ...globalErrors][0]?.text
        || 'Erreur lors de la mise à jour du mot de passe.';

      alert.error('#alert-container', errorMsg, { icon: true, closable: true });
    }
  });
});
